// extracted by mini-css-extract-plugin
export default {"container":"SearchResults_container__znrT5"};